


























































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'EventHeader'
  vue:
    props: ['event', 'canEdit']
    data: ->
      openMoreActionsBar: null
      showNameEdit: false
      showDateEdit: false
    computed:
      backgroundStyle: ->
        style = { backgroundColor: '#13b9d5' }
        url = @ctxHeroImageURL(@event)
        style.backgroundImage = "url('#{url}')" if url
        style
      isSingleDayEvent: -> dayjs(@event.local_start_day).isSame(dayjs(@event.local_end_day), 'day')
      currentStatusBg: ->
        switch @event.current_status
          when 'draft', 'unscheduled' then 'bg-draft'
          when 'published' then 'bg-recess'
          when 'expired', 'canceled', 'deactivated' then 'bg-grey-dark'
      confirmationStatusBg: ->
        return 'bg-draft' if @event.potential_unconfirmed
        return 'bg-recess' if @event.potential_confirmed
        return 'bg-red' if @event.potential_denied
      nextEvent: ->
        currentIndex = @event.occurrence_index
        series = @event.event_set?.event_series || []
        nextEvent = (series.filter (e) -> e.occurrence_index is currentIndex + 1)[0]
        nextEvent || false
      previousEvent: -> 
        currentIndex = @event.occurrence_index
        series = @event.event_set?.event_series || []
        previousEvent = (series.filter (e) -> e.occurrence_index is currentIndex - 1)[0]
        previousEvent || false
      eventIsInactive: -> ['canceled', 'deactivated'].includes @event.current_status
    methods:
      host: () ->
        name = @ctxSupplierOrg(@event).name || ""
        name = "#{name} - #{@ctxSupplierSubOrg(@event).name}" if @ctxSupplierSubOrg(@event).name
        name

      badgeSrc: (type) -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_#{type}_badge.png"
      nextEventClicked: ->
        @$router.push({ name: 'EventShowPage', params: { eventId: @nextEvent.id, tab: 'overview' } }) if @nextEvent
      previousEventClicked: ->
        @$router.push({ name: 'EventShowPage', params: { eventId: @previousEvent.id, tab: 'overview' } }) if @previousEvent
      navigateToWizardPage: (page) -> @$router.push({ name: 'EventEditPage', params: { eventId: @$route.params.eventId }, query: { page } })
      toggleDateEdit: -> @showDateEdit = !@showDateEdit
      toggleNameEdit: -> @showNameEdit = !@showNameEdit
      
export default VueOptions.vue settings
